
import NavBar from "@/components/NavBar/NavBar.vue";
export default {
  components: {
    NavBar,
  },
};
